/**
 * Whether finance has locked the financial period a closeout period falls in (BOPS-170).
 *
 * This is not a new contract: BOPS-138 already ships financial periods as a real billing-service
 * resource, backed by the `fiscal_period` table (restore-core, ADR-009) and read by the enterprise
 * Invoicing screen in rebill. This page asks the same endpoint the same question — the facility
 * just needs one month's answer rather than the whole list.
 *
 * Base path there is `/api/billing/financial-periods`; provider-portal's interceptor already
 * prefixes `/api`, so the path below is the remainder.
 */
export const financialPeriodPath = {
  RETRIEVE_PERIODS: '/billing/financial-periods',
};
